import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const TransporterTaxInfoComponent = ({ GSTRegistrationType, GSTType, onInnerFormChange, selectedTransporters }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="GST No"
            name="GSTNo"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'GSTInfo.GSTNo',
                selectedTransporters?.GSTInfo
              )
            }}
            type="text"
            value={selectedTransporters?.GSTInfo?.GSTNo}
          />
          <InputContainer
            label="PAN No"
            name="PANNo"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'GSTInfo.PANNo',
                selectedTransporters?.GSTInfo
              )
            }}
            type="text"
            value={selectedTransporters?.GSTInfo?.PANNo}
          />
          <InputContainer
            label="GST Type"
            labelField="Text"
            list={GSTType}
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'GSTInfo.GSTTypeId',
                selectedTransporters?.GSTInfo
              )
            }}
            optionName="Choose GSTType"
            type="select"
            value={selectedTransporters?.GSTInfo?.GSTTypeId}
            valueField="Value"
          />
          <InputContainer
            label="GST Registration Type"
            labelField="Text"
            list={GSTRegistrationType}
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'GSTInfo.GSTRegistrationTypeId',
                selectedTransporters?.GSTInfo
              )
            }}
            optionName="Choose GSTRegistrationType"
            type="select"
            value={selectedTransporters?.GSTInfo?.GSTRegistrationTypeId}
            valueField="Value"
          />

        </div>
      }
      expandedPanel="TaxInfo"
      headerTitle="Tax Info"
    />
  </>
)
export default TransporterTaxInfoComponent;
